import React from "react";
import { FaInfoCircle } from "react-icons/fa";
import { statusChip } from "../helpers";
import { FaBell } from "react-icons/fa";
import { getReminderCount } from "../helpers";

const MobileCards = ({ rows, onOpenMessage, onOpenReminderHistory }) => {
  return (
    <div className="md:hidden px-5 pb-6 sm:px-8 space-y-2">
      {rows.length === 0 && (
        <div className="text-center py-10 text-slate-600 dark:text-slate-300">
          Aucun résultat avec ces filtres.
        </div>
      )}

      {rows.map((r) => (
        <div
          key={`card-${r.id}`}
          className="rounded-xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/40 p-3 shadow-sm"
        >
          {/* Ligne 1 : date + statut */}
          <div className="flex items-center justify-between">
            <p className="text-[11px] text-slate-600 dark:text-slate-300">
              {new Date(r.date_achat).toLocaleDateString()}
            </p>
            <span
              className={`inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-semibold ${statusChip(
                r.statut_reglement,
              )}`}
            >
              {r.statut_reglement}
            </span>
          </div>

          {/* Ligne 2 : article + user + total + bouton info */}
          <div className="mt-1 flex items-center justify-between gap-3">
            <div className="min-w-0">
              <div className="truncate text-sm font-semibold text-slate-900 dark:text-slate-100">
                {r.Article ? r.Article.nom : "Règlement Inscription"}
              </div>
              <div className="truncate text-xs text-slate-700 dark:text-slate-300">
                {r.User?.prenom} {r.User?.nom}
              </div>
            </div>

            <div className="flex items-center gap-2 shrink-0">
              <div className="text-right">
                <div className="text-sm font-bold tabular-nums">
                  {parseFloat(r.prix_total || 0).toFixed(2)} €
                </div>
              </div>
              <button
                onClick={() => onOpenReminderHistory(r)}
                title="Historique des rappels"
                aria-label="Historique des rappels"
                className="inline-flex h-8 min-w-8 items-center justify-center gap-1 rounded-full bg-orange-100 px-2 text-[11px] font-bold text-orange-700 hover:bg-orange-200 dark:bg-orange-950/40 dark:text-orange-200"
              >
                <FaBell className="text-[12px]" />
                <span>{getReminderCount(r)}</span>
              </button>
              <button
                onClick={() => onOpenMessage(r)}
                title="Informations"
                aria-label="Informations"
                className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white hover:bg-blue-700"
              >
                <FaInfoCircle className="text-[14px]" />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MobileCards;
